import { useGetWorksitesQuery } from '../../../redux/api/BisnodeApi';

export const useWorksites = (organizationNumber: string | undefined) => {
  const { data: worksites, isLoading: loadingWorksites } = useGetWorksitesQuery(
    organizationNumber || '',
    {
      skip: !organizationNumber,
    }
  );

  return { worksites, loadingWorksites };
};
